module.exports = __webpack_public_path__ + "img/logo.3af2e80d.png";